// extracted by mini-css-extract-plugin
export default {"widgetSection":"StudentRightWidgetSpace_widgetSection__hLVP5"};